import {
	utils
} from "./utils";
import {
	Notify
} from "./notifications";
import { useAuthStore } from "../stores/auth";

// Helper function to get access token from store with fallback to localStorage
function getAccessToken() {
	const authStore = useAuthStore();
	return authStore.accessToken || localStorage.getItem('access_token') || localStorage.getItem('access-token');
}

export class http {
	static serverUrl = import.meta.env.VITE_SERVER_URL;
	static universalAccountOpeningUrl =
		import.meta.env.VITE_UNIVERSAL_ACCOUNT_OPENING_URL;
  static sso_url = import.meta.env.VITE_SSO_API;
  static auth_url = import.meta.env.VITE_AUTH_SERVER;

	static ussdUrl = import.meta.env.VITE_USSD_URL;

	static put(url) {
		utils.logger(url);
		return (
			fetch(`${this.serverUrl}${url}`, {
				method: "PUT",
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + getAccessToken(),
				},
				// body: JSON.stringify(data)
			})
			// .then(res => res.json())
			.catch((e) => {
				utils.logger(e);
				Notify.fire(
					"Sorry!",
					"There something wrong with your request",
					"error"
				);
			})
		);
	}

	static delete(url) {
		utils.logger(url);
		return (
			fetch(`${this.serverUrl}${url}`, {
				method: "DELETE",
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + getAccessToken(),
				},
				// body: JSON.stringify(data)
			})
			// .then(res => res.json())
			.catch((e) => {
				utils.logger(e);
				Notify.fire(
					"Sorry!",
					"There something wrong with your request",
					"error"
				);
			})
		);
	}

	static post(url, data) {
		utils.logger(url, data);
		return (
			fetch(`${this.serverUrl}${url}`, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + getAccessToken(),
				},
				body: JSON.stringify(data),
			})
			// .then(res => res.json())
			.catch((e) => {
				utils.logger(e);
				Notify.fire(
					"Sorry!",
					"There something wrong with your request",
					"error"
				);
			})
		);
	}

	static postNoAuth(url, data) {
		utils.logger(url, data);
		return (
			fetch(`${this.serverUrl}${url}`, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					// "Authorization": "Bearer "+localStorage.getItem("access_token"),
				},
				body: JSON.stringify(data),
			})
			//  .then(res => { return res.json()})
			.catch((e) => {
				console.log(e);
				utils.logger(e);
				Notify.fire(
					"Sorry!",
					"There something wrong with your request",
					"error"
				);
			})
		);
	}

  static post_sso_no_auth(url, data) {
    utils.logger(url, data);
    return (
      fetch(`${this.sso_url}${url}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          // "Authorization": "Bearer "+localStorage.getItem("access_token"),
        },
        body: JSON.stringify(data),
      })
        //  .then(res => { return res.json()})
        .catch((e) => {
          console.log(e);
          utils.logger(e);
          Notify.fire(
            "Sorry!",
            "There something wrong with your request",
            "error"
          );
        })
    );
  }


  static post_sso(url, data) {
    utils.logger(url, data);
    return (
      fetch(`${this.sso_url}${url}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
           "Authorization": "Bearer " + getAccessToken(),
        },
        body: JSON.stringify(data),
      })
        //  .then(res => { return res.json()})
        .catch((e) => {
          console.log(e);
          utils.logger(e);
          Notify.fire(
            "Sorry!",
            "There something wrong with your request",
            "error"
          );
        })
    );
  }

  static post_auth_no_auth(url, data) {
    utils.logger(url, data);
    return (
      fetch(`${this.auth_url}${url}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
        .catch((e) => {
          console.log(e);
          utils.logger(e);
          Notify.fire(
            "Sorry!",
            "There something wrong with your request",
            "error"
          );
        })
    );
  }

  // Authenticated POST to auth server
  static post_auth(url, data) {
    utils.logger(url, data);
    return (
      fetch(`${this.auth_url}${url}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer " + getAccessToken(),
        },
        body: JSON.stringify(data),
      })
        .catch((e) => {
          console.log(e);
          utils.logger(e);
          Notify.fire(
            "Sorry!",
            "There something wrong with your request",
            "error"
          );
        })
    );
  }

  // Authenticated GET to auth server
  static get_auth(url) {
    utils.logger(url);
    return (
      fetch(`${this.auth_url}${url}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer " + getAccessToken(),
        },
      })
        .catch((e) => {
          console.log(e);
          utils.logger(e);
          Notify.fire(
            "Sorry!",
            "There something wrong with your request",
            "error"
          );
        })
    );
  }

	static postAuthUssd(url, data) {
		return (
			fetch(`${this.ussdUrl}${url}`, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					"Authorization": "Bearer " + getAccessToken(),
				},
				body: JSON.stringify(data),
			})
			//  .then(res => { return res.json()})
			.catch((e) => {
				console.log(e);
				utils.logger(e);
				Notify.fire(
					"Sorry!",
					"There something wrong with your request",
					"error"
				);
			})
		);
	}

  static postNoAuthAndAccountOpeningUrl(url, data) {
    return (
      fetch(`${this.universalAccountOpeningUrl}${url}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          // "Authorization": "Bearer "+localStorage.getItem("access_token"),
        },
        body: JSON.stringify(data),
      })
        // .then(res => res.json())
        .catch((e) => {
          utils.logger(e);
          Notify.fire(
            "Sorry!",
            "There something wrong with your request",
            "error"
          );
        })
    );
  }

  static async postAccountOpeningAsyncData(url, data) {
    // Default options are marked with *
    fetch(`${this.universalAccountOpeningUrl}${url}`, {
      method: "POST", // *GET, POST, PUT, DELETE, etc.
      mode: "cors", // no-cors, *cors, same-origin
      cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
      credentials: "same-origin", // include, *same-origin, omit
      headers: {
        "Content-Type": "application/json",
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      redirect: "follow", // manual, *follow, error
      referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
      body: JSON.stringify(data), // body data type must match "Content-Type" header
    });
    // return response.json(); // parses JSON response into native JavaScript objects
  }

  static get(url) {
    utils.logger(url);
    return fetch(`${this.serverUrl}${url}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      // body: JSON.stringify(data)
    })
      .catch((e) => {
        utils.logger(e);
        Notify.fire(
          "Sorry!",
          "There something wrong with your request",
          "error"
        );
      });
  }

  static getNoAuthAndAccountOpeningUrl(url) {
    return (
      fetch(`${this.universalAccountOpeningUrl}${url}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          // "Authorization": "Bearer "+localStorage.getItem("access_token"),
        },
        //body: JSON.stringify(data),
      })
        // .then(res => res.json())
        .catch((e) => {
          utils.logger(e);
          Notify.fire(
            "Sorry!",
            "There something wrong with your request",
            "error"
          );
        })
    );
  }

	static download(url) {
		utils.logger(url);
		return fetch(`${this.serverUrl}${url}`, {
				method: "GET",
				headers: {
					Authorization: "Bearer " + getAccessToken(),
				},
				// body: JSON.stringify(data)
			})
			.then((res) => res.blob())
			.catch((e) => {
				utils.logger(e);
				Notify.fire(
					"Sorry!",
					"There something wrong with your request",
					"error"
				);
			});
	}

	static getIdentity(url) {
		utils.logger(url);
		return fetch(`${this.serverUrl}${url}`, {
				method: "GET",
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + getAccessToken(),
				},
				// body: JSON.stringify(data)
			})
			.then((res) => res.json())
			.catch((e) => {
				utils.logger(e);
				Notify.fire(
					"Sorry!",
					"There something wrong with your request",
					"error"
				);
			});
	}

	static getNoAuth(url) {
		utils.logger(url);
		return fetch(`${this.serverUrl}${url}`, {
				method: "GET",
				headers: {
					"Content-Type": "application/json",
					// "Authorization": "Bearer "+localStorage.getItem("access_token"),
				},
				// body: JSON.stringify(data)
			})
			.catch((e) => {
				utils.logger(e);
				Notify.fire(
					"Sorry!",
					"There something wrong with your request",
					"error"
				);
			});
	}

  static get_sso_no_auth(url) {
    utils.logger(url);
    return fetch(`${this.sso_url}${url}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        // "Authorization": "Bearer "+localStorage.getItem("access_token"),
      },
      // body: JSON.stringify(data),
    })
      .catch((e) => {
        utils.logger(e);
        Notify.fire(
          "Sorry!",
          "There something wrong with your request",
          "error"
        );
      });
  }
	static getNoAuthUssd(url) {
		utils.logger(url);
		return fetch(`${this.ussdUrl}${url}`, {
				method: "GET",
				headers: {
					"Content-Type": "application/json",
					//"Authorization": "Bearer "+localStorage.getItem("access_token"),
				},
				// body: JSON.stringify(data)
			})
			.catch((e) => {
				utils.logger(e);
				Notify.fire(
					"Sorry!",
					"There something wrong with your request",
					"error"
				);
			});
	}

	// data should be type FormData
	static postFormDataNoAuth(url, data) {
		utils.logger(url, data);

		let requestOptions = {
			method: "POST",
			body: data,
		};

		return (
			fetch(`${this.serverUrl}${url}`, requestOptions)
			// .then(response => response.json())
			.catch((e) => {
				utils.logger(e);
				Notify.fire(
					"Sorry!",
					"There something wrong with your request",
					"error"
				);
			})
		);
	}
}